// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HDCk","colMin":"styles_colMin__j9_oh"};